import * as React from 'react';

import { FormControlLabel, Typography } from '@mui/material';
import { Field } from 'react-final-form';

import { useIntl } from '@kamernet/core/Intl';

import { Checkbox } from '@kamernet/components/FormFields/final-form/Checkbox/CheckboxInput';

import { SideFiltersFormFieldStyles } from './SideFiltersFormFieldStyles';

export const OtherSuitableFormFields = () => {
  const { T } = useIntl();
  return (
    <React.Fragment>
      <Typography variant="subtitle2">{T('LBL_GLOBAL_OTHER')}</Typography>
      <section className={SideFiltersFormFieldStyles.controlsGroupColumn}>
        <FormControlLabel
          control={
            <Field<boolean>
              name="isSmokingInsideAllowed"
              component={Checkbox}
              type="checkbox"
            />
          }
          label={T('LBL_SMOKING_INSIDE_ALLOWED')}
        />

        <FormControlLabel
          control={
            <Field<boolean>
              name="isPetsInsideAllowed"
              component={Checkbox}
              type="checkbox"
            />
          }
          label={T('LBL_PETS_INSIDE_ALLOWED')}
        />
      </section>
    </React.Fragment>
  );
};
